import React from "react";
import Select from 'react-select';

const StepAntecedentes = ({ formData, setFormData, comunas, errores }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

    
const comunaOptions = comunas.map((item) => ({
    value: item._id,
    label: `${item.codigoComuna} - ${item.nombreComuna}`,
  }));

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-3 md:grid-cols-3 gap-4" >
        <div className="flex flex-col">
          <label className="block font-medium text-sm text-gray-700">RUT</label>
          <input
            name="rut"
            value={formData.rut || ""}
            onChange={handleChange}
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm px-3 py-2"
          />
          {errores.rut && <p className="text-red-500 text-sm">{errores.rut}</p>}
        </div>
        <div className="col-span-2">
          <div className="flex flex-col">
            <label className="block font-medium text-sm text-gray-700">Nombre</label>
            <input
              name="nombre"
              value={formData.nombre || ""}
              onChange={handleChange}
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm px-3 py-2"
            />
            {errores.nombre && <p className="text-red-500 text-sm">{errores.nombre}</p>}
          </div>
        </div>
      </div>
      <div className="grid grid-cols-3 md:grid-cols-3 gap-4" >
        <div className="flex flex-col">
          <label className="block font-medium text-sm text-gray-700">Teléfono</label>
          <input
            type="telefono"
            name="telefono"
            value={formData.telefono || ""}
            onChange={handleChange}
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm px-3 py-2"
          />
          {errores.telefono && <p className="text-red-500 text-sm">{errores.telefono}</p>}
        </div>
        <div  className="flex flex-col">
          <label className="block font-medium text-sm text-gray-700">Email</label>
          <input
            type="email"
            name="email"
            value={formData.email || ""}
            onChange={handleChange}
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm px-3 py-2"
          />
          {errores.email && <p className="text-red-500 text-sm">{errores.email}</p>}
        </div>
        <div className="flex flex-col">
          <label className="text-xs font-semibold mb-1">Comuna</label>
          <Select
            options={comunaOptions}
            value={comunaOptions.find((option) => option.value === formData.idComuna)}
            onChange={(selectedOption) => {
              if (selectedOption) {
                const comunaSeleccionada = comunas.find(c => c._id === selectedOption.value);

                setFormData((prev) => ({
                  ...prev,
                  idComuna: selectedOption.value,
                  nombreComuna: comunaSeleccionada?.nombreComuna || '',
                  nombreCiudad: comunaSeleccionada?.nombreCiudad || '',
                }));
              } else {
                // Si se limpia el campo
                setFormData((prev) => ({
                  ...prev,
                  idComuna: '',
                  nombreComuna: '',
                  nombreCiudad: '',
                }));
              }
            }}
            className="text-xs"
            placeholder="Buscar ..."
            isClearable
          />
        </div>
      </div>
      <div className="grid grid-cols-3 md:grid-cols-3 gap-4" >
        <div className="col-span-2">
            <div  className="flex flex-col">
            <label className="block font-medium text-sm text-gray-700">Dirección</label>
            <input
              name="direccion"
              value={formData.direccion || ""}
              onChange={handleChange}
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm px-3 py-2"
            />
            {errores.direccion && <p className="text-red-500 text-sm">{errores.direccion}</p>}
          </div>
        </div>  
        <div  className="flex flex-col">
          <label className="block font-medium text-sm text-gray-700">Número</label>
          <input
            type="numero"
            name="numero"
            value={formData.numero || ""}
            onChange={handleChange}
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm px-3 py-2"
          />
          {errores.numero && <p className="text-red-500 text-sm">{errores.numero}</p>}
        </div>
      </div>







    </div>
  );
};

export default StepAntecedentes;
